import { render, staticRenderFns } from "./ForestCountryBoxes.vue?vue&type=template&id=741bb604&scoped=true&"
import script from "./ForestCountryBoxes.vue?vue&type=script&lang=ts&"
export * from "./ForestCountryBoxes.vue?vue&type=script&lang=ts&"
import style0 from "./ForestCountryBoxes.vue?vue&type=style&index=0&id=741bb604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741bb604",
  null
  
)

export default component.exports